import { CommonProp, CompactHeader, FirstTier, generate, PageContentLayout, PageWrapper } from '@acin/ui-core';
import React from 'react';
import { ControlMappingsRuns } from '../../../components/ControlMappingsRuns';
import { PageLayout } from '../../../components/PageLayout';
import * as SC from './ControlMappings.styled';

export interface ControlMappingsProps extends CommonProp {
  className?: string;
}

export const ControlMappings: React.FC<ControlMappingsProps> = (props) => {
  const { className } = props;

  return (
    <SC.ControlMappings data-testid={generate(['control-mappings-page'], props)} className={className}>
      <PageLayout>
        <PageWrapper header={<CompactHeader firstTier={<FirstTier title="Control Mappings" variation="parent" />} />}>
          <PageContentLayout headerHeight={116}>
            <ControlMappingsRuns />
          </PageContentLayout>
        </PageWrapper>
      </PageLayout>
    </SC.ControlMappings>
  );
};
